import { useRef, useState } from "react";
import { Distribution, StoreSearchApiParams, StoreStock } from "../types";
import storeStockListApi from "../api/storeStockListApi";
import { Severity } from "../../../type";

const limit = 10;

/**
 * 店舗用在庫一覧取得
 */
export default function useStoreStockList(showAlert: (msg: string, severity?: Severity) => void) {
  const [total, setTotal] = useState(0); // 在庫のレコードの総数
  const [stockList, setStockList] = useState<StoreStock[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isMoreLoading, setIsMoreLoading] = useState(false);
  const [offset, setOffset] = useState(0);
  const isFastLoading = useRef(false); // 二重読み込み防止
  const [fireMoreLoadEvent, setFireMoreLoadEvent] = useState(false); // スクロール最下層に達した時、値を変更して発火させるイベント
  const [init, setInit] = useState(false);
  const [storeUpdated, setStoreUpdated] = useState('');
  const [storehouseUpdated, setStorehouseUpdated] = useState('');
  // const [distribution, setDistribution] = useState<Distribution>({
  //   distributionCd: '',
  //   distributionName: '',
  // });

  const get = async (searchParams: StoreSearchApiParams) => {
    isFastLoading.current = true;
    setIsLoading(true);
    try {
      const res = await storeStockListApi({...(searchParams ?? {}), ...{offset: 0, limit}});
      setTotal(res.total);
      setStockList(structuredClone(res.stocks));
      setStorehouseUpdated(res.storehouseUpdated);
      setStoreUpdated(res.storeUpdated);
      setOffset(res.stocks.length);
      // setDistribution(res.distribution);
    } catch (err) {
      console.error(err);
      showAlert('在庫一覧情報の取得に失敗しました。', 'error');
    } finally {
      isFastLoading.current = false;
      setIsLoading(false);
    }
  }

  const getMore = async (searchParams: StoreSearchApiParams) => {
    if (stockList.length >= total || !init) {
      return;
    }

    isFastLoading.current = true;
    setIsMoreLoading(true);
    try {
      const res = await storeStockListApi({
        limit,
        offset,
        ...searchParams
      });
      setTotal(res.total);
      setStockList((prev) => [...prev, ...res.stocks]);
      setOffset((prev) => prev + res.stocks.length);
      // setDistribution(res.distribution);
    } catch (err) {
      console.error(err);
      showAlert('在庫一覧情報の取得に失敗しました。', 'error');
    } finally {
      isFastLoading.current = false;
      setIsMoreLoading(false);
    }
  };

  return [{total, stockList, isLoading, isMoreLoading, isFastLoading, fireMoreLoadEvent, storeUpdated, storehouseUpdated}, {setStockList, get, getMore, setFireMoreLoadEvent, setInit}] as const;
}
